export default "__VITE_PUBLIC_ASSET__6b08595e__"